// A donor's name as a single click: the dashboard opens the quick-view bottom sheet (onOpen),
// every other screen goes to the donor page. Contact actions (Call / WhatsApp / Email) live in
// the sheet and on the profile, so the name itself needs no menu.

import { Link } from "react-router-dom";

import { cn } from "@/lib/utils";

export function DonorLink({
  name,
  donorId,
  onOpen,
  className,
}: {
  name: string;
  donorId?: number | null;
  /** Given → clicking calls this (bottom sheet) instead of navigating. */
  onOpen?: (donorId: number) => void;
  className?: string;
}) {
  if (donorId == null) return <span className={cn("truncate", className)}>{name}</span>;

  const style = cn(
    "max-w-full truncate rounded-sm text-left underline decoration-dotted underline-offset-4 outline-none hover:text-primary focus-visible:ring-2 focus-visible:ring-ring/50",
    className
  );

  return onOpen ? (
    <button type="button" className={style} onClick={() => onOpen(donorId)}>
      {name}
    </button>
  ) : (
    <Link to={`/donors/${donorId}`} className={style}>
      {name}
    </Link>
  );
}
